export var MaintenanceTaskType;
(function (MaintenanceTaskType) {
    MaintenanceTaskType["FieldInspection"] = "Field inspection";
    MaintenanceTaskType["LitterLeafRemoval"] = "Litter & leaf removal";
    MaintenanceTaskType["InfillManagementFullSurface"] = "Infill management (full surface)";
    MaintenanceTaskType["InfillManagementIsolated"] = "Infill management (isolated)";
    MaintenanceTaskType["SpecalistDecompaction"] = "Specialist decompaction and cleaning";
    MaintenanceTaskType["MossWeedAlgaeVegetationTreatment"] = "Moss, weed, algae & vegetation treatment";
    MaintenanceTaskType["DeepCleaningAndRenovation"] = "Deep cleaning and renovation";
    MaintenanceTaskType["Other"] = "Other";
})(MaintenanceTaskType || (MaintenanceTaskType = {}));
//# sourceMappingURL=maintenanceTaskType.enum.js.map